import { StatusEnum } from 'constants/status';

import { NEXT_ACTION_SEVERITY } from '../PathToSubmission.constants';

export const SEVERITY_ICON = {
  [NEXT_ACTION_SEVERITY.BLOCKING]: StatusEnum.ERROR,
  [NEXT_ACTION_SEVERITY.IN_PROGRESS]: StatusEnum.IN_PROGRESS,
  [NEXT_ACTION_SEVERITY.READY]: StatusEnum.SUCCESS,
};
